import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const content = this.element.querySelector('.secondary-text');
        this.element.querySelector('.primary-text').addEventListener('click', () => {

            if (this.element.classList.contains('expanded')) {
                this.element.classList.remove('expanded');
                content.style.maxHeight = null;
            } else {
                this.element.classList.add('expanded');
                content.style.maxHeight = content.scrollHeight + 'px';
            }

        });
    }
}
